import { __awaiter, __generator } from "tslib";
import { getPricingApiConfig } from './config/actions';
import { fetchPricesGetByIds } from './http/fetch-prices-by-ids.get';
export var fetchFamilyPrices = function (familyIds) { return __awaiter(void 0, void 0, void 0, function () {
    var isSFCCPricingOn, prices, response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                isSFCCPricingOn = getPricingApiConfig().isSFCCPricingOn;
                if (!isSFCCPricingOn) return [3 /*break*/, 2];
                return [4 /*yield*/, fetchPricesGetByIds(familyIds, "f" /* Family */)];
            case 1:
                response = _b.sent();
                prices = (_a = response === null || response === void 0 ? void 0 : response.search_phrase_suggestions) === null || _a === void 0 ? void 0 : _a.c_prices;
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, fetchPricesGetByIds(familyIds, "f" /* Family */)];
            case 3:
                prices = _b.sent();
                _b.label = 4;
            case 4: return [2 /*return*/, prices];
        }
    });
}); };
